import { ChevronLeft, ChevronRight } from "lucide-react"
import {
  Button,
  Calendar as CalendarRac,
  CalendarCell,
  CalendarGrid,
  CalendarGridBody,
  CalendarGridHeader,
  CalendarHeaderCell,
  CalendarProps,
  composeRenderProps,
  Heading,
} from "react-aria-components"
import type { DateValue } from "@internationalized/date"

import { cn } from "../../lib/utils"

function Calendar({ className, ...props }: CalendarProps<DateValue>) {
  return (
    <CalendarRac
      className={composeRenderProps(className, (className) =>
        cn("w-fit", className)
      )}
      {...props}
    >
      <header className="flex w-full items-center gap-1 pb-4">
        <Button
          slot="previous"
          className="text-muted-foreground hover:text-foreground data-focus-visible:bg-accent data-focus-visible:ring-ring/50 size-7 rounded-md data-focus-visible:ring-[3px] outline-hidden"
        >
          <ChevronLeft className="size-4" />
        </Button>
        <Heading className="grow text-center text-sm font-medium" />
        <Button
          slot="next"
          className="text-muted-foreground hover:text-foreground data-focus-visible:bg-accent data-focus-visible:ring-ring/50 size-7 rounded-md data-focus-visible:ring-[3px] outline-hidden"
        >
          <ChevronRight className="size-4" />
        </Button>
      </header>
      <CalendarGrid>
        <CalendarGridHeader>
          {(day) => (
            <CalendarHeaderCell className="text-muted-foreground size-8 text-center text-xs font-medium">
              {day}
            </CalendarHeaderCell>
          )}
        </CalendarGridHeader>
        <CalendarGridBody>
          {(date) => (
            <CalendarCell
              date={date}
              className="data-hovered:bg-accent data-pressed:bg-accent data-selected:bg-primary data-selected:text-primary-foreground data-focus-visible:bg-accent data-focus-visible:ring-ring/50 data-unavailable:text-muted-foreground/30 data-outside-month:text-muted-foreground/40 size-8 cursor-pointer rounded-md text-center text-sm data-focus-visible:ring-[3px] outline-hidden data-unavailable:cursor-not-allowed data-selected:data-focus-visible:ring-offset-2"
            />
          )}
        </CalendarGridBody>
      </CalendarGrid>
    </CalendarRac>
  )
}

export { Calendar }
